import { Link } from "react-router-dom";
import { ChevronRight, Trophy } from "lucide-react";
import { LMS_HERO } from "../../data/plTeams";

export function LmsBanner() {
  return (
    <Link to="/lms" data-testid="home-lms-banner"
      className="ua-tile lms-pitch group relative flex w-full items-center gap-3 overflow-hidden rounded-[22px] border-[4px] border-[#0B1F33] p-2 pr-4 text-white sm:gap-5">
      <img src={LMS_HERO} alt="Cartoon football mascot in a blue and white hooped shirt standing on a trophy" className="h-24 w-24 shrink-0 rounded-2xl border-[3px] border-[#0B1F33] object-cover transition-transform group-hover:rotate-[-4deg] group-hover:scale-105 sm:h-36 sm:w-36" />
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-1.5 text-[10px] font-extrabold uppercase tracking-[0.25em] text-[#FFE14D] sm:text-xs"><Trophy className="h-3.5 w-3.5" strokeWidth={3} /> New · Premier League 26/27</span>
        <span className="ua-logo block text-3xl leading-none sm:text-6xl">Last Man Standing</span>
        <span className="mt-1 inline-block rotate-[-1.5deg] rounded-md bg-[#FFE14D] px-2.5 font-comic text-xs text-[#0B1F33] sm:text-lg">Run an LMS with your mates — one pick a week, lose and you're out!</span>
      </span>
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-[3px] border-[#0B1F33] bg-[#35E07A] transition-transform group-hover:translate-x-1 sm:h-14 sm:w-14">
        <ChevronRight className="h-7 w-7 text-[#0B1F33]" strokeWidth={4} />
      </span>
    </Link>
  );
}
